import { MessageTag, ReplyVerifyingMessage } from "../general";

export class SetUserGroupsRequest extends ReplyVerifyingMessage {
    	/** The unique tag for this message type */
	public tag : MessageTag = MessageTag.REQ_SET_USER_GROUPS;
	public static tag : MessageTag = MessageTag.REQ_SET_USER_GROUPS;

  /**
   * Construct a new {@link SetUserGroupsRequest}.
   */
  constructor (
    public groups: any,
    public objectId: any
    )
  {
    super();
  }
}


// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/group-management/set-user-group-request.ts